import type { FigureVarData } from "../types/FigureVarData";

/**
 * Convert an object to an array of FigureVarData
 *
 * @param obj - Object to convert
 * @returns Array of FigureVarData
 */
export const objToFigureVarData = (obj: object): FigureVarData[] =>
  Object.entries(obj).map(([varName, value]) => ({ varName, value: String(value) }));
